module.exports = __webpack_public_path__ + "static/media/T20.PNG.5cf0285f.png";